import { format } from 'date-fns';

const GYM_TIME_ZONE = 'Europe/Amsterdam';

const GymTimeFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: GYM_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
});

// A narrowcasting screen shows the wall clock at the gym, so every date is a
// Date whose *local* parts spell out gym time, which keeps the date-fns maths
// simple.
export function toGymTime(instant) {
    const parts = GymTimeFormatter
        .formatToParts(new Date(instant))
        .reduce((acc, { type, value }) => {
            acc[type] = value;
            return acc;
        }, {});

    return new Date(
        `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`
    );
}

// The `date` filter is matched against the stored value, which is gym time
// rather than UTC, so the boundaries go out labelled as UTC while carrying
// gym time.
export const toDateFilter = gymTime => format(gymTime, "yyyy-MM-dd'T'HH:mm:ss'Z'");
